import React, { useEffect, useState } from 'react'
import {
    Select,
    Form,
    Button
} from 'antd'

import { 
    SendOutlined
} from '@ant-design/icons'

import { useApi } from '../../Utils'
import useEnqueueReport from './useEnqueueReport'

export const pad = (n: any, width: any, z = '0') => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default function ReportInventoryProcess() {
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const { enqueue, submitting } = useEnqueueReport('processInventories')
    const { data, loading: _loading } = useApi<any>('get', 'v3/gestion/processInventories')

    const [availableProcess, setAvailableProcess] = useState<any[]>([])

    useEffect(() => {
        if (data?.data) {
            setAvailableProcess(data.data)
        }
    }, [data])

    useEffect(() => {
        setLoading(_loading)
    }, [_loading])

    const { Option } = Select

    const onFinish = (data: any) => {
        enqueue(data)
    }

    return <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} form={form} onFinish={onFinish} initialValues={{
        year: `${new Date().getFullYear()}`
        // year: `${new Date().getFullYear()}${pad(new Date().getMonth() + 1, 2)}`
    }}>
        <p>Para la descarga de tomas de inventario realizadas en Manager, agrega los documentos a continuación.</p>
        <br />
        <Form.Item name="documentType" label="Tomas de Inventario" required rules={[
            { required: true, message: 'Debes seleccionar al menos un documento.' }
        ]}>
            <Select
                disabled={loading || submitting}
                showSearch
                allowClear
                mode="multiple"
                placeholder='Selecciona las tomas'
            >
                {availableProcess.map(field => (
                    <Option value={field} key={field}>{field}</Option>
                ))}
            </Select>
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting} disabled={loading} icon={<SendOutlined />} className='Accounting--DownloadBtn' >
          Solicitar Informe
        </Button>
    </Form>
}
